import { effect } from '@angular/core';
import { PickSignalFactory, SignalFactory } from './SignalFactory';

/**
 * Access a property of an object and create a signal for it if it's a function.
 */
export function resolveSignalProperty<T, K extends keyof T>(
  obj: PickSignalFactory<T, K> | undefined = undefined,
  path: K
): void {
  const value = obj?.[path];
  if (value && typeof value === 'function') {
    const signalFactory = value as SignalFactory<T[K]>;
    const signal = signalFactory();

    delete obj[path];

    effect(
      () => {
        obj[path] = signal();
      },
      { allowSignalWrites: true }
    );
  }
}
